{
  "metadata": {
    "id": "aura-dark",
    "name": "Aura",
    "description": "Портировано из темы «Aura» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "aura.json",
      "project": "daltonmenezes",
      "url": "https://github.com/daltonmenezes/aura-theme",
      "upstreamFile": "packages/ui/src/theme/themes/aura.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.9,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.468,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.1,
      "syntaxVsTextMinDeltaE": 16.4,
      "chartsMinDeltaE": 49.1,
      "textSeparationDeltaE": 27.5,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "string",
          "b": "type",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#a277ff",
      "hover": "#ad87ff",
      "active": "#b592ff",
      "foreground": "#000000",
      "muted": "#a277ff80",
      "emphasis": "#a277ff"
    },
    "surface": {
      "background": "#15141b",
      "foreground": "#edecee",
      "muted": "#2a2930",
      "mutedForeground": "#a1a0a4",
      "elevated": "#323238",
      "elevatedForeground": "#edecee",
      "raised": "#4c4b51",
      "raisedForeground": "#edecee",
      "overlay": "#15141bcc",
      "subtle": "#212027"
    },
    "interactive": {
      "border": "#4e4d54",
      "borderHover": "#515056",
      "borderFocus": "#a277ff",
      "selection": "#edecee29",
      "selectionForeground": "#edecee",
      "focus": "#a277ff59",
      "focusRing": "#a277ff61",
      "cursor": "#edecee",
      "hover": "#edecee1c",
      "active": "#edecee29"
    },
    "status": {
      "error": "#ff6767",
      "errorForeground": "#000000",
      "errorBackground": "#ff676724",
      "errorBorder": "#ff676773",
      "warning": "#ffca85",
      "warningForeground": "#000000",
      "warningBackground": "#ffca8524",
      "warningBorder": "#ffca8573",
      "success": "#61ffca",
      "successForeground": "#000000",
      "successBackground": "#61ffca24",
      "successBorder": "#61ffca73",
      "info": "#82e2ff",
      "infoForeground": "#000000",
      "infoBackground": "#82e2ff24",
      "infoBorder": "#82e2ff73"
    },
    "pr": {
      "open": "#61ffca",
      "draft": "#a1a0a4",
      "blocked": "#ffca85",
      "merged": "#ff6767",
      "closed": "#ff6767"
    },
    "syntax": {
      "base": {
        "background": "#38373d",
        "foreground": "#edecee",
        "comment": "#82adc9",
        "keyword": "#b391ff",
        "string": "#61ffca",
        "number": "#ff7676",
        "function": "#ffca85",
        "variable": "#edecee",
        "type": "#61ffca",
        "operator": "#c9c6ca"
      },
      "tokens": {
        "commentDoc": "#82adc9",
        "stringEscape": "#c9c6ca",
        "keywordImport": "#b391ff",
        "storageModifier": "#b391ff",
        "functionCall": "#ffca85",
        "method": "#ffca85",
        "variableProperty": "#ffca85",
        "variableOther": "#edecee",
        "variableGlobal": "#ff7676",
        "variableLocal": "#c9c6ca",
        "parameter": "#edecee",
        "constant": "#ff7676",
        "class": "#61ffca",
        "className": "#61ffca",
        "interface": "#61ffca",
        "struct": "#61ffca",
        "enum": "#61ffca",
        "typeParameter": "#61ffca",
        "namespace": "#61ffca",
        "module": "#b391ff",
        "tag": "#b391ff",
        "jsxTag": "#b391ff",
        "tagAttribute": "#ffca85",
        "tagAttributeValue": "#61ffca",
        "boolean": "#ff7676",
        "decorator": "#b391ff",
        "label": "#ffca85",
        "regexp": "#61ffca"
      }
    },
    "charts": {
      "series": [
        "#a277ff",
        "#82e2ff",
        "#61ffca",
        "#ffca85",
        "#ff6767"
      ]
    },
    "chat": {
      "background": "#15141b",
      "userMessage": "#edecee",
      "userMessageBackground": "#323238",
      "assistantMessage": "#edecee",
      "assistantMessageBackground": "#2a2930",
      "timestamp": "#a1a0a4",
      "divider": "#4e4d54",
      "typing": "#a1a0a4"
    },
    "loading": {
      "spinner": "#a277ff",
      "spinnerTrack": "#2a2930",
      "skeleton": "#2a2930",
      "shimmer": "#434248"
    },
    "tools": {
      "background": "#2a2930",
      "border": "#4e4d54",
      "headerHover": "#414046",
      "icon": "#a277ff",
      "title": "#edecee",
      "description": "#a1a0a4",
      "edit": {
        "added": "#61ffca",
        "addedBackground": "#61ffca24",
        "removed": "#ff6767",
        "removedBackground": "#ff676724",
        "modified": "#82e2ff",
        "modifiedBackground": "#82e2ff24",
        "lineNumber": "#a1a0a4"
      }
    },
    "markdown": {
      "heading1": "#edecee",
      "heading2": "#edecee",
      "heading3": "#edecee",
      "heading4": "#edecee",
      "link": "#a277ff",
      "linkHover": "#ad87ff",
      "inlineCode": "#61ffca",
      "inlineCodeBackground": "#2a2930",
      "blockquote": "#a1a0a4",
      "blockquoteBorder": "#4e4d54",
      "listMarker": "#a277ffbf",
      "bold": "#edecee",
      "italic": "#edeceee6",
      "strikethrough": "#a1a0a4",
      "hr": "#4e4d54"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#dfaea2",
        "foreground": "#000000",
        "contrast": 10.71
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c76f59",
        "foreground": "#000000",
        "contrast": 5.85
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ca9a5f",
        "foreground": "#000000",
        "contrast": 8.3
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dfdcac",
        "foreground": "#000000",
        "contrast": 14.97
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a6ce65",
        "foreground": "#000000",
        "contrast": 11.64
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#a7e2a6",
        "foreground": "#000000",
        "contrast": 14.07
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#65cc75",
        "foreground": "#000000",
        "contrast": 10.45
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#67cdb7",
        "foreground": "#000000",
        "contrast": 10.99
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#aad3dd",
        "foreground": "#000000",
        "contrast": 13.07
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#649dc0",
        "foreground": "#000000",
        "contrast": 7.13
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5159c1",
        "foreground": "#ffffff",
        "contrast": 5.92
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#8485cb",
        "foreground": "#000000",
        "contrast": 6.2
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a059c4",
        "foreground": "#000000",
        "contrast": 4.72
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#cea7da",
        "foreground": "#000000",
        "contrast": 10.16
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf62a3",
        "foreground": "#000000",
        "contrast": 5.49
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d48199",
        "foreground": "#000000",
        "contrast": 7.4
      }
    ]
  }
}
